import React from 'react';
import { LoadingState, LoadingStateProps } from './LoadingComponents';
import { ErrorState } from './ErrorComponents';
import { EmptyState } from './EmptyStateComponents';

interface PageStateProps {
  loading?: boolean;
  error?: string | Error;
  isEmpty?: boolean;
  emptyStateProps?: any;
  loadingStateProps?: Partial<LoadingStateProps>;
  errorStateProps?: any;
  children: React.ReactNode;
}

export const PageState: React.FC<PageStateProps> = ({
  loading,
  error,
  isEmpty,
  emptyStateProps = {},
  loadingStateProps = {},
  errorStateProps = {},
  children,
}) => {
  if (loading) {
    return <LoadingState {...loadingStateProps} />;
  }
  if (error) {
    return <ErrorState error={error} {...errorStateProps} />;
  }
  if (isEmpty) {
    return <EmptyState {...emptyStateProps} />;
  }
  return <>{children}</>;
};
